export const privacyLink = `${process.env.REACT_APP_API_URL}/privacy`;
export const termsLink = `${process.env.REACT_APP_API_URL}/terms`;